module.exports = __webpack_public_path__ + "static/CircularStd-Black-a7d0eebb9d2e5cc322735d10e8b7f95c.woff2";